import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const React = require('react');

function withDataLoaded({ WithData, WithoutData = null, data, EmptyArrayIsStillData = false }) {
  function storeHasKeys(store, storeKeys) {
    return storeKeys.every((key) => {
      return Array.isArray(store[key]) ? store[key].length > 0 : !!store[key];
    });
  }

  class WithDataLoaded extends React.Component {
    state = {
      optionalChecks: {},
    };

    hasUnmounted = false;

    static propTypes = {
      store: PropTypes.object.isRequired,
      ownProps: PropTypes.object.isRequired,
    };

    componentDidMount() {
      this.checkData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      if (
        data.some(
          (item) =>
            Array.isArray(item.storeKeys) &&
            item.storeKeys.some((key) => !this.props?.store?.[key] && prevProps?.store?.[key])
        )
      ) {
        this.checkData();
      }
    }

    componentWillUnmount() {
      this.hasUnmounted = true;
    }

    checkData = async () => {
      const { store } = this.props;

      data?.forEach(async (item, i) => {
        if (!this.hasItem(item, i)) {
          if (this.optionalIsTrue(item)) {
            await item.loadDataFn(store);
            if (!this.hasUnmounted) {
              this.setState({
                optionalChecks: {
                  ...this.state.optionalChecks,
                  [i]: true,
                },
              });
            }
          } else if (item.loadDataFn) {
            await item.loadDataFn(store);
          }
        }
      });
    };

    hasItem = (item, i) => {
      const { store } = this.props;

      let itemFound = false;
      if (item.ignoreIfTrueFn && item.ignoreIfTrueFn(store)) {
        return true;
      }

      if (item.storeKeys && item.checkDataFn) {
        itemFound = item.checkDataFn(store) && storeHasKeys(store, item.storeKeys);
      } else if (item.storeKeys) {
        itemFound = storeHasKeys(store, item.storeKeys);
      } else if (item.checkDataFn) {
        itemFound = item.checkDataFn(store);
      }

      if (!itemFound && this.optionalIsTrue(item)) {
        return !!this.state.optionalChecks[i];
      }

      return itemFound;
    };

    optionalIsTrue(item) {
      return (
        (typeof item.optional !== 'function' && item.optional) ||
        (typeof item.optional === 'function' && item.optional())
      );
    }

    render() {
      const { ownProps } = this.props;
      if (
        data.every(
          (item, i) =>
            this.hasItem(item, i) ||
            ((this.props.store?.[item.storeKeys] || this.props.store?.[item.storeKeys?.[i]]) &&
              (item.emptyIsStillData || EmptyArrayIsStillData))
        )
      ) {
        return <WithData {...ownProps} />;
      }

      return WithoutData ? <WithoutData {...ownProps} /> : null;
    }
  }

  return connect((state, ownProps) => ({
    ownProps,
    store: state,
  }))(WithDataLoaded);
}

export default withDataLoaded;
